<template>
    <li
        class="product-filter-color"
        :class="{ 'selected-color': modelValue }"
    >
        <v-input
            :model-value="modelValue"
            class="cursor-pointer"
            @click="onChange"
            hide-details
        >
            <ColorSwatch
                :title="attrObj.name"
                :aria-label="attrObj.name"
                :color="attrObj.colors"
                :width="32"
                :height="32"
                :disable-border="modelValue"
            ></ColorSwatch>
        </v-input>
    </li>
</template>

<script lang="ts" setup>
    import type {
        ProductFilterAttributeValue
    } from '~/types';
    import ColorSwatch from '~/components/color/ColorSwatch/ColorSwatch.vue';
    
    defineProps<{
        modelValue: boolean;
        attrObj: ProductFilterAttributeValue;
    }>();

    const emit = defineEmits<{
        'update:model-value': [value: boolean];
    }>();

    function onChange(val: Nullable<boolean>): void {
        emit('update:model-value', Boolean(val));
    }
</script>

<style lang="scss">
.product-filter-color {
    $swatch-size: 42px;
    
    width: $swatch-size;
    height: $swatch-size;
    min-width: $swatch-size;
    min-height: $swatch-size;
    padding: 1px;
    cursor: pointer;
    border-radius: 4px;
    border: 4px solid transparent;

    &.selected-color {
        border: 4px solid rgba(var(--v-theme-primary), 1);
    }

    span {
        visibility: hidden;
    }
}
</style>
